var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting-item" },
    [
      _c(
        "el-form-item",
        { attrs: { label: "关联设置" } },
        [
          _vm._l(_vm.eventSaveObject, function(eventItem, eventKey) {
            return _c(
              "div",
              { key: eventKey, staticClass: "setting-item_event" },
              [
                _c(
                  "el-form-item",
                  {
                    staticStyle: { "margin-left": "10px" },
                    attrs: { label: "触发选项" }
                  },
                  [
                    _vm.isSelectType(_vm.formId)
                      ? [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "选择选项" },
                              model: {
                                value: eventItem.triggerValue,
                                callback: function($$v) {
                                  _vm.$set(eventItem, "triggerValue", $$v)
                                },
                                expression: "eventItem.triggerValue"
                              }
                            },
                            _vm._l(_vm.getFormOptions(_vm.formId), function(
                              item
                            ) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.value, value: item.label }
                              })
                            }),
                            1
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isInputType(_vm.formId)
                      ? [
                          _c("el-input", {
                            attrs: { placeholder: "请输入触发关键字" },
                            model: {
                              value: eventItem.triggerValue,
                              callback: function($$v) {
                                _vm.$set(eventItem, "triggerValue", $$v)
                              },
                              expression: "eventItem.triggerValue"
                            }
                          })
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(eventItem.emit, function(contactItem, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "add-contact" },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择关联表单项",
                                filterable: "",
                                "filter-method": function(filterStr) {
                                  return (_vm.selectFilterValue = filterStr)
                                }
                              },
                              on: {
                                "visible-change": function($event) {
                                  arguments[0] || (_vm.selectFilterValue = "")
                                },
                                focus: function($event) {
                                  _vm.focusEventId = eventKey
                                }
                              },
                              model: {
                                value: contactItem.form,
                                callback: function($$v) {
                                  _vm.$set(contactItem, "form", $$v)
                                },
                                expression: "contactItem.form"
                              }
                            },
                            _vm._l(
                              _vm.getFilterForm(eventKey, contactItem.form),
                              function(item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value
                                  }
                                })
                              }
                            ),
                            1
                          ),
                          _vm._v(" "),
                          _vm.isSelectType(contactItem.form)
                            ? [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { placeholder: "选择选项" },
                                    model: {
                                      value: contactItem.value,
                                      callback: function($$v) {
                                        _vm.$set(contactItem, "value", $$v)
                                      },
                                      expression: "contactItem.value"
                                    }
                                  },
                                  _vm._l(
                                    _vm.getFormOptions(contactItem.form),
                                    function(item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.value,
                                          value: item.label
                                        }
                                      })
                                    }
                                  ),
                                  1
                                )
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isInputType(contactItem.formId)
                            ? [
                                _c("el-input", {
                                  attrs: { placeholder: "请输入触发关键字" },
                                  model: {
                                    value: contactItem.value,
                                    callback: function($$v) {
                                      _vm.$set(contactItem, "value", $$v)
                                    },
                                    expression: "contactItem.value"
                                  }
                                })
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "danger", round: "" },
                              on: {
                                click: function($event) {
                                  return _vm.removeContactItem(eventKey, index)
                                }
                              }
                            },
                            [_vm._v("\n            删除该项")]
                          )
                        ],
                        2
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", round: "" },
                        on: {
                          click: function($event) {
                            return _vm.addContactItem(eventKey)
                          }
                        }
                      },
                      [_vm._v("\n          添加关联项")]
                    ),
                    _vm._v(" "),
                    eventItem.emit.length > 0
                      ? _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择组合方式" },
                            model: {
                              value: eventItem.eventType,
                              callback: function($$v) {
                                _vm.$set(eventItem, "eventType", $$v)
                              },
                              expression: "eventItem.eventType"
                            }
                          },
                          _vm._l(_vm.makeUpTypeList, function(item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value }
                            })
                          }),
                          1
                        )
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { "margin-left": "10px" },
                    attrs: { label: "关联选项" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择目标表单项",
                          filterable: "",
                          "filter-method": function(filterStr) {
                            return (_vm.selectFilterValue = filterStr)
                          }
                        },
                        on: {
                          "visible-change": function($event) {
                            arguments[0] || (_vm.selectFilterValue = "")
                          },
                          focus: function($event) {
                            _vm.focusEventId = eventKey
                          }
                        },
                        model: {
                          value: eventItem.on.form,
                          callback: function($$v) {
                            _vm.$set(eventItem.on, "form", $$v)
                          },
                          expression: "eventItem.on.form"
                        }
                      },
                      _vm._l(
                        _vm.getFilterForm(eventKey, eventItem.on.form),
                        function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value }
                          })
                        }
                      ),
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择目标的出现方式" },
                        model: {
                          value: eventItem.on.action,
                          callback: function($$v) {
                            _vm.$set(eventItem.on, "action", $$v)
                          },
                          expression: "eventItem.on.action"
                        }
                      },
                      _vm._l(_vm.eventConfigList, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "add-event_button" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger" },
                        on: {
                          click: function($event) {
                            _vm.dialogManage(_vm.removeEvent).show(eventKey)
                          }
                        }
                      },
                      [_vm._v("删除选项")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.submitEvent(eventKey)
                          }
                        }
                      },
                      [_vm._v("确定添加")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "add-event_button" },
            [
              _c(
                "el-button",
                { attrs: { type: "text" }, on: { click: _vm.addEvent } },
                [_vm._v("添加选项")]
              )
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "删除关联",
            visible: _vm.removeEvent.visible,
            width: "384px",
            "plugin-name": "ElLeave"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.removeEvent, "visible", $event)
            }
          }
        },
        [
          _c("span", { attrs: { slot: "leave-title" }, slot: "leave-title" }, [
            _vm._v("确认删除该关联吗？")
          ]),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "leave-auxiliary" }, slot: "leave-auxiliary" },
            [_vm._v("删除后该关联无法恢复！")]
          ),
          _vm._v(" "),
          _c("i", {
            staticClass: "el-icon-erp-kulian",
            attrs: { slot: "leave-icon" },
            slot: "leave-icon"
          }),
          _vm._v(" "),
          _c(
            "template",
            { slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.submitRemoveEvent }
                },
                [_vm._v("确认")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.dialogManage(_vm.removeEvent).hide()
                    }
                  }
                },
                [_vm._v("取消")]
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09459d50", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09459d50","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Setting/base_setting/SettingEvent.vue
// module id = null
// module chunks = 